setPaymentAuthorization